import { useTranslation } from 'react-i18next';
import i18n from '../../services/i18n.js';

// No default export in order to enforce the 'tCustom' name use to avoid possible bugs
// eslint-disable-next-line import/prefer-default-export
const useCustomTranslation = () => {
  // We have to pass the i18n instance like this to avoid conflicts on adopters repositories
  // "translation" is the namespace name (the translation.json file)
  const {
    t
  } = useTranslation('translation', {
    i18n
  });
  return {
    tCustom: t
  };
};

export { useCustomTranslation };
//# sourceMappingURL=useCustomTranslation.js.map
